<template>
  <div class="container">
    <div v-show="!isyy">
      <div class="list" id="list" ref="list">
        <ul>
          <li v-for="(item, index) in msglist" :key="index">
            <RightItem
              :id="item.id"
              :type="item.type"
              :content="item.content"
              :selectarr="item.selectarr"
              v-if="item.me"
            ></RightItem>
            <LeftItem
              :id="item.id"
              :type="item.type"
              :content="item.content"
              :selectarr="item.selectarr"
              @problem="send"
              @make="makes"
              v-else
            ></LeftItem>
            <div v-scroll style="height: 0"></div>
          </li>
        </ul>

        <!-- <button @touchstart.prevent="paly()" @touchend.prevent="pause()">哈喽哈喽</button> -->
      </div>
      <div class="bottom">
        <div class="btnList">
          <van-button
            type="default"
            round
            size="small"
            @click="getText('身份证')"
            >身份证</van-button
          >
          <van-button
            type="default"
            round
            size="small"
            @click="getText('驾驶证')"
            >驾驶证</van-button
          >
          <van-button type="default" round size="small" @click="getText('护照')"
            >护照</van-button
          >
          <van-button type="default" round size="small" @click="getText('公章')"
            >公章</van-button
          >
        </div>
        <div class="line"></div>
        <div class="input-send" v-if="true">
          <div v-show="show" class="flex w100 ai-center jc-between">
            <van-button plain type="info" class="send" @click="show = !show"
              >语音</van-button
            >
            <van-field
              v-model="text"
              placeholder="请输入聊天内容..."
              class="input"
              @keyup.enter="send()"
              v-if="show"
            />
            <van-button plain type="info" class="send" @click="send()"
              >发送</van-button
            >
          </div>
          <div
            v-show="!show"
            class="flex jc-center ai-center flex-wrap"
            style="user-select: none; background: #f6f6f6"
          >
            <div class="w100 flex jc-center ai-center" style>
              <van-icon name="arrow-down" size="24px" @click="show = true" />
            </div>
            <div class="w100 text-center" style="padding: 0px 0px 8px">
              按住说话
            </div>
            <div
              @touchstart.prevent="paly()"
              @touchend.prevent="pause()"
              class="flex jc-center ai-center"
              style="width: 20%"
            >
              <img
                src="@/assets/yy.jpg"
                alt
                class="db w100"
                style="pointer-events: none; margin-bottom: 20px"
              />
            </div>
          </div>

          <!-- <button type="primary" size="small"  @touchstart.prevent="paly()" @touchend.prevent="pause()"  style=" flex: 1;height: 4vh;     border-radius: 0px;" >按住说话</button> -->
        </div>
      </div>
    </div>
    <div v-show="isyy">
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <span class="tips">温馨提示：户政业务请到户籍所在地派出所办理</span>
          <van-field
            v-model="other_value.name"
            name="用户名"
            label="事项名"
            placeholder="事项名"
            readonly
          />

          <van-field
            is-link
            readonly
            name="picker"
            label="办理部门"
            placeholder="办理部门"
            v-model="police"
            @click="blbm"
            :rules="[{ required: true, message: '请选择办理部门' }]"
          />

          <van-popup
            v-model="showPickerb"
            position="bottom"
            :close-on-click-overlay="false"
          >
            <van-picker
              show-toolbar
              ref="pic"
              :columns="columns"
              @confirm="onConfirmb"
              @cancel="showPickerb = false"
            />
          </van-popup>
          <van-field
            is-link
            readonly
            name="picker"
            label="时间段"
            placeholder="点击时间段"
            @click="sjd"
            v-model="iattxt"
            :rules="[{ required: true, message: '请选择时间段' }]"
          />
          <van-popup
            v-model="showPicker"
            position="bottom"
            :close-on-click-overlay="false"
          >
            <van-picker
              show-toolbar
              ref="timer"
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            >
              <template #option="option">
                <div>
                  <div>姓名：{{ option.text }}</div>
                  <div>年龄：{{ option.text }}</div>
                </div>
              </template>
            </van-picker>
          </van-popup>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>

    <!-- <audio src="http://tzwjw.gaj.taizhou.gov.cn/newadmin/uploads/files/1615430092.mp3" autoplay ></audio> -->
  </div>
</template>

<script>
import Vue from "vue";
import LeftItem from "@/components/LeftItem";
import RightItem from "@/components/RightItem";
import { Toast } from "vant";

Vue.directive("scroll", {
  inserted(el) {
    el.scrollIntoView();
  },
});

export default {
  name: "Chat",
  components: { LeftItem, RightItem },
  data: () => {
    return {
      text: "",
      show: true,
      question_type: "",
      isyy: false,
      msglist: [
        {
          id: 1,
          type: 1,
          content: `您好，泰警通办智能客服为您服务。如果您有公安户政、出入境管理、治安、政务服务等领域的常见问题需要咨询的，请点击下面的链接。如果我回答不了您的问题，请拨打咨询电话或前往窗口咨询，回复“人工服务“获取咨询电话列表。谢谢！`,
          me: false,
          selectarr: [],
          isarr: false,
        },
      ],
      is_audio: 0,
      autoplay: false,
      src: "",
      value: "",
      columns: [],
      showPicker: false,
      showPickerb: false,
      other_value: { ymd: "" },
      timearr: [],
      iattxt: "",
      police: "",
      //t改
      idgetList: [],
      depidgetList: [],
      idFlag: 0,
      police_map_id: "",
      iat_id: "",
    };
  },
  created() {
    this.getwechat();
    this.initContent();
  },
  methods: {
    // 获取初始化
    initContent() {
      function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return decodeURI(pair[1]);
          }
        }
        return false;
      }
      this.police_map_id = getQueryVariable("police_map_id");
      this.iask_id = getQueryVariable("iask_id");
      this.text = getQueryVariable("title");
      if (this.text) {
        this.idFlag = this.idFlag + 2;
        this.send();
        // this.getText(this.text);
      } else {
        this.getproblem();
        this.text = "";
      }
    },
    async blbm() {
      var params = {};
      if (this.iask_id != "") {
        params = {
          police_map_id: this.police_map_id,
          iask_id: this.iask_id,
        };
      } else {
        params = {
          iask_id: this.other_value.iask_id,
        };
      }

      // https://tzwjw.gaj.taizhou.gov.cn/newadmin/api/Intelligent_service/dept_list?iask_id=557208823157231616
      // let result = await this.$api.get("/matter/branch_office", {});
      let result = await this.$api.get(
        "https://tzwjw.gaj.taizhou.gov.cn/newadmin/api/Intelligent_service/dept_list",
        params
      );
      // console.log(result);
      result.forEach((x) => {
        x.text = x.label;
        if (x.children) {
          x.children.forEach((x) => {
            x.text = x.label;
          });
        }
      });
      this.columns = result;
      this.showPickerb = true;
    },
    async sjd() {
      // console.log(this.other_value.police_map_id);
      if (this.other_value.police_map_id == undefined) {
        Toast.fail("请先选择部门");
        return;
      }
      var params = {
        police_map_id: this.other_value.police_map_id,
        iask_id: this.other_value.iask_id,
      };
      let result = await this.$api.get(
        "https://tzwjw.gaj.taizhou.gov.cn/newadmin/api/matter/appoint_time_list",
        params
      );
      // let result = await this.$api.get("/matter/appoint_time_list", {});
      this.timearr = result;
      result.forEach((x) => {
        x.text = x.ymd_text;
        x.time_list.forEach((y) => {
          if (y.disable) {
            y.text = `${y.time_text}(已约满)`;
          } else {
            y.text = `${y.time_text}(预约${y.num}人)`;
          }
          // y.className = "disabled";
          // y.disabled = true;
          // y.disable = true;
        });
        x.children = x.time_list;
        x.disabled = true;
      });
      this.columns = result;
      this.showPicker = true;
      this.$nextTick(() => {
        this.$forceUpdate();
        // dom元素更新后执行，因此这里能正确打印更改之后的值
        var html = document.querySelectorAll(".van-ellipsis");
        html.forEach((x) => {
          if (x.innerText.indexOf("已约满") != -1) {
            x.classList.add("van-picker-column__item--disabled");
          }
        });
      });
    },
    onConfirm(value) {
      this.iattxt = value[0] + value[1];
      console.log(this.iattxt, "iattxt");
      if (this.iattxt.indexOf("已约满") != -1) {
        Toast.fail("该时间段已约满,请重新选择时间");
        this.iattxt = "";
      }
      var time = value[0].match(/\d+/g);
      this.other_value.ymd = time[0] + time[1] + time[2];
      for (const item of this.columns) {
        item.children.forEach((x) => {
          if (x.text == value[1]) {
            this.other_value.iat_id = x.iat_id;
            this.showPicker = false;
          }
        });
      }
      this.showPicker = false;
    },
    changeTime(value) {
      console.log(value, "chnge");
    },
    onConfirmb(value) {
      this.police = value[0] + value[1];
      for (const item of this.columns) {
        item.children.forEach((x) => {
          if (x.label == value[1]) {
            this.other_value.police_map_id = x.id;
            this.showPickerb = false;
          }
        });
      }

      this.showPickerb = false;
      this.iattxt = "";
    },
    async onSubmit() {
      // console.log(this.other_value);
      let result = await this.$api.post(
        "/matter/iask_appoint",
        this.other_value
      );
      // console.log(result);

      if (!result.error_code) {
        Toast.success("预约成功");
        setTimeout(() => {
          location.reload();
          // this.isyy = false;
        }, 5000);
      } else {
        Toast.fail(result.error_msg);
        setTimeout(() => {
          location.reload();
          // this.isyy = false;
        }, 5000);
      }
    },
    async makes() {
      this.isyy = true;
      this.other_value = {};
      // t改
      let obj = JSON.parse(localStorage.getItem("seleitem"));
      this.other_value.name = obj.title;
      this.other_value.iask_id = obj.id;
    },
    // https://tzwjw.gaj.taizhou.gov.cn/newadmin/api/Intelligent_service/hot_matter
    async getproblem(id = 0, keyword = "") {
      let url = keyword
        ? "/intelligent_service/service_answer_by_keyword"
        : "/intelligent_service/service_answer";
      let obj = keyword
        ? { question_type: sessionStorage.getItem("question_type") || "" }
        : {};
      let result = await this.$api.get(url, {
        ...{
          id,
          keyword,
          is_audio: this.is_audio,
        },
        ...obj,
      });
      this.is_audio = 0;
      if (result.isak_list[0] && result.isak_list[0].title == "人工服务") {
        let arrs = result.isak_list.splice(0, 1);
        result.isak_list = [...result.isak_list, ...arrs];
      }
      if (result.audio_content) {
        // this.src=result.audio_content
        // this.autoplay=true
        // console.log(result.audio_content);
        let audio = new Audio(result.audio_content);
        audio.play();
      }
      //  console.log(result)
      // alert(JSON.stringify(result))
      // console.log(result, 113131);
      //后期修改
      var arr111 = [
        {
          content: null,
          id: "557208823157231616",
          is_matter: "1",
          iscontent: "0",
          title: "中国公民因私出国护照办理",
          type: "1",
        },
        {
          content: null,
          id: "557208898616954880",
          is_matter: "1",
          iscontent: "0",
          title: "核发居民身份证",
          type: "1",
        },
        {
          content: null,
          id: "557206885892100096",
          is_matter: "1",
          iscontent: "0",
          title: "注销、降级",
          type: "1",
        },
        {
          content: null,
          id: "557206375487246336",
          is_matter: "1",
          iscontent: "0",
          title: "驾驶证补证、换证（遗失换证）",
          type: "1",
        },
        {
          content: null,
          id: "557206332449492992",
          is_matter: "1",
          iscontent: "0",
          title: "驾驶证补证、换证（延期换证）",
          type: "1",
        },
        {
          content: null,
          id: "557206273041371136",
          is_matter: "1",
          iscontent: "0",
          title: "驾驶证补证、换证（损毁换证)",
          type: "1",
        },
        {
          content: null,
          id: "557205145297883136",
          is_matter: "1",
          iscontent: "0",
          title: "补、换领机动车检验合格标志",
          type: "1",
        },
        {
          content: null,
          id: "557205020848689152",
          is_matter: "1",
          iscontent: "0",
          title: "补、换领机动车行驶证、号牌",
          type: "1",
        },
      ];
      if (id == 0 && this.idFlag == 0 && keyword == "") {
        sessionStorage.removeItem("seleitem");
        result.isak_list = arr111;
        // console.log("buzou1");
      } else if (id == 0 && keyword != "") {
        // console.log("zou");
      } else {
        // console.log(id,this.idFlag);
        let seleitem = JSON.parse(sessionStorage.getItem("seleitem"));
        if (seleitem) {
          if (seleitem.is_matter == 1) {
            var lista = result.isak_list.forEach((x) => {
              x.title = `${seleitem.title}的${x.title}`;
            });
          }
        }
      }
      console.log(lista);
      // console.log(arr111);
      result.type == 0 &&
        this.msglist.push({
          id: this.msglist.length + 1,
          type: 1,
          content: "按照属地管理原则，您可以按照您意向办理的分县局咨询 ",
          me: false,
          selectarr: result.isak_list,
          isarr: Array.isArray(result.isak_list),
        });
      result.type == 1 &&
        this.msglist.push({
          id: this.msglist.length + 1,
          type: 1,
          content: result.isak_list[0].content,
          me: false,
          selectarr: [],
          isarr: Array.isArray(result.isak_list),
        });
      result.type == 2 &&
        this.msglist.push({
          id: this.msglist.length + 1,
          type: 1,
          content:
            "您的问题我暂时回答不了，请拨打咨询电话或前往窗口咨询，回复“人工服务”获取咨询电话列表。谢谢！",
          me: false,
          selectarr: result.isak_list,
          isarr: Array.isArray(result.isak_list),
        });

      // console.log(result.isak_list);
    },
    async send(id, text, dep_id) {
      this.idFlag++;
      this.depidgetList.push(dep_id);
      this.idgetList.push(id);
      this.question_type = sessionStorage.getItem("question_type");
      let keyword = this.text || text;
      console.log(keyword, "11111");
      if (keyword == "人工服务") {
        sessionStorage.setItem("content", JSON.stringify(keyword));
      } else {
        sessionStorage.removeItem("content");
      }
      if (!keyword) return;
      this.msglist.push({
        id: this.msglist.length + 1,
        type: 1,
        content: this.text || text,
        me: true,
      });
      !id && this.getproblem("", keyword);
      id && this.getproblem(id);
      this.text = "";
    },

    async getwechat() {
      let res = await this.$api.get("/wechat/wechat_param", {
        url: window.location.href.split("#")[0],
      });
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        jsApiList: [
          "startRecord",
          "stopRecord",
          "playVoice",
          "uploadVoice",
          "downloadVoice",
          "translateVoice",
        ], // 必填，需要使用的JS接口列表
      });
    },
    paly() {
      console.log("按下");
      this.wx.startRecord();
    },
    pause() {
      console.log("拿起");
      this.wx.ready(() => {
        this.wx.stopRecord({
          success: (res) => {
            var localId = res.localId;
            this.wx.uploadVoice({
              localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res) => {
                var serverId = res.serverId; // 返回音频的服务器端ID
                this.wx.downloadVoice({
                  serverId: serverId, // 需要下载的音频的服务器端ID，由uploadVoice接口获得
                  isShowProgressTips: 1, // 默认为1，显示进度提示
                  success: (res) => {
                    var localIds = res.localId; // 返回音频的本地ID
                    this.wx.translateVoice({
                      localId: localIds, // 需要识别的音频的本地Id，由录音相关接口获得
                      isShowProgressTips: 1, // 默认为1，显示进度提示
                      success: (res) => {
                        if (!res.translateResult) {
                          // alert('我没听清楚,请再说一遍')
                        } else {
                          this.text = res.translateResult;
                          this.show = true;
                          this.is_audio = 1;
                          this.send("", this.text);
                        }
                      },
                    });
                  },
                });
              },
            });
          },
        });
      });
    },
    getText(text) {
      this.text = text;
      this.idFlag++;
      this.send();
    },
  },
};
</script>

<style  lang="scss">
.container {
  /deep/ .van-ellipsis {
    white-space: unset;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /deep/ .van-picker__cancel {
    display: none;
  }
}

.text-center {
  text-align: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex {
  display: flex;
}
.w100 {
  width: 100%;
}
.jc-center {
  justify-content: center;
}
.jc-between {
  justify-content: space-between;
}
.ai-center {
  align-items: center;
}
button {
  user-select: none;
}
.text-blue {
  color: #0077ff;
}
.db {
  display: block;
}
body {
  background: #f5f5f5;
}
.container {
  background: #f5f5f5;
  max-width: 100%;
  overflow-x: hidden;
  ul {
    padding: 0;
    margin: 0;
  }

  li {
    list-style: none;
  }

  .list {
    width: 100%;
    height: 100%;
    margin-bottom: 65px;
  }

  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;

    .line {
      width: 100%;
      height: 1px;
      background-color: #ddd;
    }

    .input-send {
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      align-items: center;

      .input {
        padding-right: 10px;
      }

      .send {
        width: 80px;
        height: 30px;
      }
    }
  }
}
.btnList {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.tips {
  display: inline-block;
  width: 100%;
  height: 24px;
  line-height: 24px;
  background-color: #fff;
  font-size: 14px;
  margin: 0 auto;
  color: red;
  text-indent: 2em;
}
</style>